import React, { useState, useEffect } from 'react';
import '../CSS/App.css';
import Countdown from './Countdown';
import { NavScroll } from './NavBar';
import SocialLinks from "./SocialLinks";
import Mainlogo from '../assets/MainLogo.png'; // your logo
import { CONFIG } from '../config';
import { getEvents, getActiveEvent } from '../utils/calendarService';

const Home = () => {
  const [activeEvent, setActiveEvent] = useState(null);

  useEffect(() => {
    getEvents().then(events => {
      const active = getActiveEvent(events);
      setActiveEvent(active);
    });
  }, []);

  return (
    <div className='background-component'>
      <NavScroll />

      {activeEvent ? (
        <div className="live-page-layout">
          <div className="live-event-container">
            <h2 className="live-title">LIVE NOW: {activeEvent.title.toUpperCase()}</h2>
            {activeEvent.description && <p className="live-desc">{activeEvent.description}</p>}
            <div className="twitch-embed-container live-large">
              <iframe
                src={`https://player.twitch.tv/?channel=${CONFIG.TWITCH_CHANNEL}&parent=${window.location.hostname}&muted=false`}
                allowFullScreen
                title="Twitch Player"
              ></iframe>
            </div>
          </div>
        </div>
      ) : (
        <div className="app-wrapper">
          <div className="circle-container">
            <>
              <main>
                <div className='LanDescriptText'>
                  <p>We didn't just revive Halo LAN.</p>
                  <p>We modernized it.</p>
                  <Countdown />
                </div>
              </main>
            </>
            <img src={Mainlogo} alt="Logof" className="center-logo" />
          </div>
          <script type="module" src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"></script>
          <script nomodule src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js"></script>
        </div>
      )}
      <SocialLinks />
    </div>
  );
};

export default Home;

